// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_logisticsSection__kixHs {
  background-color: var(--background-color1);
  padding: 6rem 0;
}

.styles_sectionTitle__urVTv {
  font-size: 2.2rem;
  font-weight: 700;
  text-align: center;
  color: #FFFFFF;
  margin-bottom: 1rem;
}

.styles_highlight__pHjAm {
  color: var(--brand-yellow);
}

.styles_sectionSubtitle__ONd39 {
  color: var(--brand-yellow);
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
}

.styles_divider__SwEyM {
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.3);
  border: none;
  margin: 1.5rem 0 3.5rem 0;
}

.styles_logisticsGrid__nAThQ {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 4rem;
  align-items: center;
}

@media (max-width: 900px) {
  .styles_logisticsGrid__nAThQ {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
}

.styles_logisticsTextContainer__2gYlL {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.styles_logisticsDescText__kAmHM {
  font-size: 1.1rem;
  color: #FFFFFF;
  line-height: 1.7;
  margin: 0;
}

.styles_distanceBox__WBnjk {
  background: var(--background-color0);
  border-left: 4px solid var(--brand-yellow);
  padding: 1.25rem 1.5rem;
  border-radius: 0 0.5rem 0.5rem 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  margin-top: 0.5rem;
}

.styles_distanceText__Pu7sA {
  font-size: 1.05rem;
  color: #FFFFFF;
  margin: 0;
  line-height: 1.5;
}

.styles_bulletsList__4D32r {
  list-style: none;
  padding: 0;
  margin: 1.5rem 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.styles_bulletItem__xcAqg {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}

.styles_bulletIconContainer__gut13 {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(var(--brand-yellow-rgb), 0.1) 0%, rgba(var(--brand-yellow-rgb), 0.05) 100%);
  border: 2px solid var(--brand-yellow);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--brand-yellow);
  flex-shrink: 0;
}

.styles_bulletIcon__-m3Jg {
  font-size: 1.5rem !important;
}

.styles_bulletTextWrapper__ldoWU {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.styles_vehicleType__-WFX6 {
  font-size: 1.15rem;
  font-weight: 700;
  color: #FFFFFF;
}

.styles_logisticsImageWrapper__x8wIB {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
}

.styles_logisticsImage__C7F1l {
  max-width: 100%;
  height: auto;
  border-radius: 1.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: transform 0.4s ease;
}

.styles_logisticsImage__C7F1l:hover {
  transform: scale(1.02);
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/CadastroLoja/components/LogisticsSection/styles.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,uBAAuB;EACvB,gCAAgC;EAChC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oHAAoH;EACpH,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".logisticsSection {\n  background-color: var(--background-color1);\n  padding: 6rem 0;\n}\n\n.sectionTitle {\n  font-size: 2.2rem;\n  font-weight: 700;\n  text-align: center;\n  color: #FFFFFF;\n  margin-bottom: 1rem;\n}\n\n.highlight {\n  color: var(--brand-yellow);\n}\n\n.sectionSubtitle {\n  color: var(--brand-yellow);\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  background-color: rgba(255, 255, 255, 0.3);\n  border: none;\n  margin: 1.5rem 0 3.5rem 0;\n}\n\n.logisticsGrid {\n  display: grid;\n  grid-template-columns: 1.1fr 0.9fr;\n  gap: 4rem;\n  align-items: center;\n}\n\n@media (max-width: 900px) {\n  .logisticsGrid {\n    grid-template-columns: 1fr;\n    gap: 3rem;\n  }\n}\n\n.logisticsTextContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.logisticsDescText {\n  font-size: 1.1rem;\n  color: #FFFFFF;\n  line-height: 1.7;\n  margin: 0;\n}\n\n.distanceBox {\n  background: var(--background-color0);\n  border-left: 4px solid var(--brand-yellow);\n  padding: 1.25rem 1.5rem;\n  border-radius: 0 0.5rem 0.5rem 0;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n  margin-top: 0.5rem;\n}\n\n.distanceText {\n  font-size: 1.05rem;\n  color: #FFFFFF;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.bulletsList {\n  list-style: none;\n  padding: 0;\n  margin: 1.5rem 0 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.bulletItem {\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n}\n\n.bulletIconContainer {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  background: linear-gradient(135deg, rgba(var(--brand-yellow-rgb), 0.1) 0%, rgba(var(--brand-yellow-rgb), 0.05) 100%);\n  border: 2px solid var(--brand-yellow);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--brand-yellow);\n  flex-shrink: 0;\n}\n\n.bulletIcon {\n  font-size: 1.5rem !important;\n}\n\n.bulletTextWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.vehicleType {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #FFFFFF;\n}\n\n.logisticsImageWrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n\n.logisticsImage {\n  max-width: 100%;\n  height: auto;\n  border-radius: 1.5rem;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  transition: transform 0.4s ease;\n}\n\n.logisticsImage:hover {\n  transform: scale(1.02);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logisticsSection": `styles_logisticsSection__kixHs`,
	"sectionTitle": `styles_sectionTitle__urVTv`,
	"highlight": `styles_highlight__pHjAm`,
	"sectionSubtitle": `styles_sectionSubtitle__ONd39`,
	"divider": `styles_divider__SwEyM`,
	"logisticsGrid": `styles_logisticsGrid__nAThQ`,
	"logisticsTextContainer": `styles_logisticsTextContainer__2gYlL`,
	"logisticsDescText": `styles_logisticsDescText__kAmHM`,
	"distanceBox": `styles_distanceBox__WBnjk`,
	"distanceText": `styles_distanceText__Pu7sA`,
	"bulletsList": `styles_bulletsList__4D32r`,
	"bulletItem": `styles_bulletItem__xcAqg`,
	"bulletIconContainer": `styles_bulletIconContainer__gut13`,
	"bulletIcon": `styles_bulletIcon__-m3Jg`,
	"bulletTextWrapper": `styles_bulletTextWrapper__ldoWU`,
	"vehicleType": `styles_vehicleType__-WFX6`,
	"logisticsImageWrapper": `styles_logisticsImageWrapper__x8wIB`,
	"logisticsImage": `styles_logisticsImage__C7F1l`
};
export default ___CSS_LOADER_EXPORT___;
